/**
 * How many chats a user may favourite or mute.
 *
 * These live on the `teams_connections` document, which is read on every
 * chat-list request, so they cannot be unbounded. Unlike the read watermarks
 * they are NOT evicted oldest-first — silently un-favouriting something the
 * user explicitly pinned would be a lie about their own settings. The cap is
 * enforced as a refusal instead, and is set far above any plausible number of
 * pinned conversations.
 */
export const TEAMS_CHAT_PREF_LIMIT = 200;
/**
 * The most people a call button will ever ring.
 *
 * Past this the honest answer is a meeting invitation, not an ad-hoc ring, and
 * a `users=` list is not a good way to organise one. Shared so the server stops
 * populating targets and the client stops rendering at exactly the same number.
 */
export const TEAMS_CALL_TARGET_MAX = 10;
/**
 * The Teams client deep link that starts a call.
 *
 * A plain client-side navigation — no token, no Graph request, nothing
 * server-side. The call happens in the user's Teams client; ATLAS never
 * carries media and never joins.
 *
 * Built here rather than in the component so the encoding lives in one place:
 * an address containing `+` is the case a naive `join(',')` gets wrong.
 */
export function teamsCallDeepLink(emails, withVideo = false) {
    const users = emails.map((e) => encodeURIComponent(e)).join(',');
    return `https://teams.microsoft.com/l/call/0/0?users=${users}${withVideo ? '&withVideo=true' : ''}`;
}
// ─── Sending (phase 3) ────────────────────────────────────────────────────────
/**
 * Teams' own limit is far higher, but a chat message composed in a narrow
 * sidebar is not a document. Capping here means an accidental paste of a whole
 * spec lands as a 400 from us rather than a truncation or a Graph error the user
 * cannot interpret — and the same number bounds the client-side counter, so the
 * two can never disagree.
 */
export const TEAMS_MESSAGE_MAX_LENGTH = 4000;
//# sourceMappingURL=teams.types.js.map